export const SAVED_INCOMPLETE = 0;
export const COMPLETED = 1;
export const CANCELLED = 2;